import { cssRule } from 'typestyle';

cssRule('.tb-content-popup', {
    width: '300px',
    height: '240px',
});

cssRule('.tb-half', {
    width: '50%',
    display: 'inline-block',
});

cssRule('.tb-truncated', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

